<div class="desktop">
  <div
    class="input-field date-picker"
    [ngClass]="{
      'has-value': !!fieldControl?.value,
      'has-placeholder': !!placeholder,
      'has-column-layout': layoutDirection !== 'row'
    }"
  >
    <label
      class="input-label field-label"
      [style.cursor]="'default'"
      [ngClass]="{
        'sr-text': hideLabel,
        disabled: fieldControl?.disabled
      }"
      [attr.for]="fieldId"
    >
      {{ label }}
    </label>

    <div class="input-wrapper">
      <input
        i2gInput
        tabindex="-1"
        [formControl]="fieldControl"
        [placeholder]="placeholder"
        [class]="inputClass"
      />
      <input
        #dateInput
        readonly
        class="hidden"
        tabindex="0"
        i2gInput
        [i2gFocusable]="focusableTrigger$"
        (onFocus)="picker.open()"
        matInput
        [matDatepicker]="picker"
        [max]="maxDate"
        (dateChange)="formatAndStoreDate($event)"
      />

      <mat-datepicker-toggle
        tabindex="-1"
        class="toggle"
        matSuffix
        [for]="picker"
      >
        <i2g-icon [icon]="caretIcon" matDatepickerToggleIcon></i2g-icon>
      </mat-datepicker-toggle>

      <i2g-error-message
        [dirty]="fieldControl.dirty"
        [invalid]="fieldControl.invalid"
        [errorMessage]="errorMessage"
      >
      </i2g-error-message>
    </div>
  </div>
</div>
<mat-datepicker
  #picker
  color="accent"
  (opened)="onDatePickerOpen()"
  (closed)="onDatePickerClose()"
></mat-datepicker>

<!-- For mobile devices, we trigger the system pickers -->
<i2g-input-field
  class="mobile"
  type="date"
  [attr.max]="maxDate | friendlyDate: false:undefined:undefined:format"
  [label]="label"
  [placeholder]="placeholder"
  [fieldId]="fieldId"
  [fieldControl]="fieldControl"
  [layoutDirection]="layoutDirection"
  [errorMessages]="errorMessages"
>
</i2g-input-field>
